import { CreateExportJobMutationVariables, ExportJob } from '@/API';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { GenericRepository } from '@/repository/GenericRepository.ts';
import * as APITypes from '@/API.ts';

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

const searchExportJobsWithoutDebugIfno = /* GraphQL */ `query SearchExportJobs(
    $filter: SearchableExportJobFilterInput
    $sort: [SearchableExportJobSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableExportJobAggregationInput]
) {
    searchExportJobs(
        filter: $filter
        sort: $sort
        limit: $limit
        nextToken: $nextToken
        from: $from
        aggregates: $aggregates
    ) {
        items {
            id
            exportName
            listType
            reportId
            status
            statusMessage
            filterInput
            filterFields
            outputFormat
            s3Key
            totalRecords
            fileSize
            startedAt
            expiresAt
            createdAt
            updatedAt
            owner
            authorizedReaders
            __typename
        }
        nextToken
        total
        aggregateItems {
            name
            result {
                ... on SearchableAggregateScalarResult {
                    value
                }
                ... on SearchableAggregateBucketResult {
                    buckets {
                        key
                        doc_count
                        __typename
                    }
                }
            }
            __typename
        }
        __typename
    }
}
` as GeneratedQuery<
  APITypes.SearchExportJobsQueryVariables,
  APITypes.SearchExportJobsQuery
>;

export class ExportJobRepository extends GenericRepository<ExportJob> {
  constructor() {
    super();
  }

  public async save(exportJob: ExportJob): Promise<ExportJob> {
    return (
      await this.client.graphql({
        query: `mutation CreateExportJob(
                  $input: CreateExportJobInput!
                  $condition: ModelExportJobConditionInput
                ) {
                  createExportJob(input: $input, condition: $condition) {
                    id
                    exportName
                    listType
                    reportId
                    status
                    statusMessage
                    filterInput
                    filterFields
                    outputFormat
                    s3Key
                    totalRecords
                    fileSize
                    startedAt
                    expiresAt
                    createdAt
                    updatedAt
                    owner
                    authorizedReaders
                    __typename
                  }
                }
                ` as GeneratedMutation<
          APITypes.CreateExportJobMutationVariables,
          APITypes.CreateExportJobMutation
        >,
        variables: {
          input: exportJob,
        } as CreateExportJobMutationVariables,
      })
    ).data.createExportJob;
  }

  async search(queryVariables: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: searchExportJobsWithoutDebugIfno,
        variables: queryVariables,
      })
    ).data.searchExportJobs;
  }

  async delete(exportJobId: string): Promise<void> {
    await this.client.graphql({
      query: `mutation DeleteExportJob(
                $input: DeleteExportJobInput!
                $condition: ModelExportJobConditionInput
              ) {
                deleteExportJob(input: $input, condition: $condition) {
                  id
                  exportName
                  listType
                  reportId
                  status
                  statusMessage
                  filterInput
                  filterFields
                  outputFormat
                  s3Key
                  totalRecords
                  fileSize
                  startedAt
                  expiresAt
                  createdAt
                  updatedAt
                  owner
                  authorizedReaders
                  debugInfo
                  __typename
                }
              }
              ` as GeneratedMutation<
        APITypes.DeleteExportJobMutationVariables,
        APITypes.DeleteExportJobMutation
      >,
      variables: {
        input: {
          id: exportJobId,
        },
      },
    });
  }
}
